module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cEIus"))).then(() => parcelRequire('iDabs'));